const initialState = {
    filter: { endDate: null, startDate: null },
    rawData: [],
    hasData: false,
    dateSelected: {
        startDate: null,
        endDate: null
    },
    ehsTeamLeaders: [],
    rscCountries: [],
    kpis: {},
    sitesDetails: {},
    isLoading: true,
    resources: [],
    selectedGroupingColumns: ["resourceId"],
    actualGroupingColumns: ["resourceId"],
    filterControls: [],
};
export default (state = initialState, action) => {
    switch (action.type) {
        case "SET_EHS_DASHBOARD_FILTER":
            return {
                ...state,
                filter: action.payload
            };
        case "SET_RSC_COUNTRIES":
            return {
                ...state,
                rscCountries: action.payload
            }
        case "SET_EHS_RAW_DATA":
            return {
                ...state,
                rawData: action.payload
            };
        case "SET_EHS_KPIS":
            return {
                ...state,
                kpis: action.payload
            };
        case "SET_EHS_DASHBOARD_FILTER":
            return {
                ...state,
                filter: action.payload
            };
        case "SET_EHS_DASHBORAD_TEAM_LEADERS":
            return {
                ...state,
                ehsTeamLeaders: action.payload
            }
        case "SET_EHS_DASHBOARD_ISLOADING":
            return {
                ...state,
                isLoading: action.payload
            }
        case "SET_EHS_SELECTED_DATES":
            return {
                ...state,
                dateSelected: action.payload
            }
        case "SET_EHS_TEAM_GROUPING_COLUMNS":
            return {
                ...state,
                selectedGroupingColumns: action.payload
            }
        case "SET_EHS_ACTUAL_TEAM_GROUPING_COLUMNS":
            return {
                ...state,
                actualGroupingColumns: action.payload
            }
        case "SET_EHS_FILTER_CONTROLS":
            return {
                ...state,
                filterControls: action.payload
            }
        case "SET_EHS_KPIS_DETAILS":
            return {
                ...state,
                sitesDetails: action.payload
            };
        case "SET_EHS_ALL_RESOURCES":
            return {
                ...state,
                resources: action.payload
            }
        default: { return state; }
    }
}